import clientApplication from './clientApplication';
import clientList from './clientList';
import cardList from './cardList';
import creditAllocation from './creditAllocation';

export default { clientApplication, clientList, cardList, creditAllocation };
